import React, { useRef, useState } from "react";
import {
  ColDef,
  RowClickedEvent,
  RowClassParams,
  RowStyle,
} from "ag-grid-community";
import { useQueryClient } from "react-query";
import {
  useDeleteUserTransaction,
  useGetClientTransaction,
} from "features/ClientInfo/api";
import { useClientsState } from "atoms/clientsAtom";
import moment from "moment";
import { Transaction } from "types";

import { Button, EButtonVariant } from "components/Button/Button";
import { Table } from "components/Table/Table";
import { SearchInput } from "components/SearchInput/SearchInput";

import styles from "../../styles.module.css";

import { useFilterTransactions } from "./useFilterTransactions";

const colDefs: ColDef<Transaction>[] = [
  {
    headerName: "№",
    field: "clienttransactionid",
    resizable: false,
    width: 80,
    flex: 1,
  },
  {
    headerName: "Дата",
    field: "time",
    resizable: false,
    flex: 2,
    valueFormatter: (data) => moment(data.value).format("DD.MM.YYYY"),
  },
  { headerName: "Сумма", field: "total", resizable: false, flex: 1 },
  { headerName: "Комментарий", field: "comment", resizable: false, flex: 5 },
];

export const BonusOperations = (): JSX.Element => {
  const [selectedRow, setSelectedRow] = useState<string>("");
  const [searchText, setSearchText] = useState<string>("");
  const queryClient = useQueryClient();
  const { clientsState } = useClientsState();
  const gridRef = useRef<any>(null);

  const { mutate: deleteTransaction } = useDeleteUserTransaction();

  const { data: clientTransactions = [] } = useGetClientTransaction(
    clientsState.activeItem?.clientid || ""
  );

  const filteredTransactions = useFilterTransactions(
    searchText,
    clientTransactions
  );

  const handleRefresh = () => {
    queryClient.invalidateQueries(["get-client-transaction"]);
    queryClient.invalidateQueries({
      queryKey: ["get-transaction-calculation"],
    });
  };

  const handleRowClick = (e: RowClickedEvent<any, any>) => {
    setSelectedRow((prev) =>
      prev === e.data.clienttransactionid ? "" : e.data.clienttransactionid
    );
  };

  const getRowStyle = (
    params: RowClassParams<Transaction>
  ): RowStyle | undefined => {
    if (params.data && selectedRow === params.data.clienttransactionid) {
      return {
        backgroundColor: "#f7f4fd",
      };
    }
  };

  const handleDeleteClick = () => {
    if (selectedRow) {
      deleteTransaction(String(selectedRow), {
        onSuccess: () => {
          setSelectedRow("");
        },
      });
    }
  };

  return (
    <div className={styles.container}>
      <div className="w-72 mb-4">
        <SearchInput callback={setSearchText} />
      </div>
      <Table
        height={300}
        ref={gridRef}
        rowData={filteredTransactions}
        colDefs={colDefs}
        onRowClicked={handleRowClick}
        getRowStyle={getRowStyle}
      />
      <div className="flex items-center gap-2 mt-4">
        <Button
          variant={EButtonVariant.SECONDARY}
          icon="refresh"
          onClick={handleRefresh}
        >
          Обновить
        </Button>
        <Button
          variant={EButtonVariant.PRIMARY}
          icon="delete"
          onClick={handleDeleteClick}
        >
          Удалить
        </Button>
      </div>
    </div>
  );
};
